import owd from 'owd/owd';

export default class System extends owd.Module {
    constructor(app) {
        super(app);
        
        this.init();
    }
    
    init() {
        const windows = /Windows/gi.test(navigator.userAgent);
        
        if(windows) {
            $('html').addClass('windows');
        }
    }
}